// Modules
import { useOutlet } from "react-router-dom";

// Components
import HeaderStatusInfo from "components/molecules/HeaderStatusInfo/HeaderStatusInfo";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import Text from "components/atoms/Text/Text";
import CollapsibleTable from "components/atoms/CollapsibleTable/CollapsibleTable";
import ExpandedRowTable from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import Spinner from "components/atoms/Spinner/Spinner";
import { Head } from "components/molecules/Head/Head";

// Styles
import styles from "containers/MonthlyDeclaration/MonthlyDeclarationPage.module.css";
import theme from "styles/theme";

// Constants
import { PageTitles, MONTHLY_DECLARATIONS as Constants } from "constants/global";
import { generateExpandRowHeaders } from "containers/MonthlyDeclaration/MonthlyDeclarationCustomFilter/useCustomSearchFilterIcon";

// Hooks
import { useMonthlyDeclaration } from "containers/MonthlyDeclaration/useMonthlyDeclarationPage";

const MonthlyDeclarationPage = () => {
	const childRouteElement = useOutlet();

	const { voucherGroupList, isSelectionAvailable, selectedVoucherGroupCodeDetails, loading, popOverClose, generateCols, generateTableDisplayData, pathname, statusBarInfo } =
		useMonthlyDeclaration();

	return (
		<div className="w-full flex flex-col relative min-h-screen">
			{loading && <Spinner type="transparent" />}
			<Head>{PageTitles.MONTHLY_DECLARATIONS}</Head>
			{!childRouteElement && (
				<>
					<div className={styles?.root}>
						<HeaderStatusInfo message={statusBarInfo?.message} background={statusBarInfo?.background} />
						{!isSelectionAvailable && <PageTitle showBackIcon={false} title={Constants.PAGE_TITLE} subTitle={Constants.PAGE_DESCRIPTION} />}
						{isSelectionAvailable && <PageTitle showBackIcon={false} title={selectedVoucherGroupCodeDetails?.voucherGroupDesc ?? ""} subTitle={Constants.GROUP_DESCRIPTION} />}
					</div>

					{!isSelectionAvailable ? (
						<>
							{voucherGroupList?.groupList[pathname]?.map((item, index) => {
								return (
									<div key={`${item?.voucher_group_code.toString()}-${index}`}>
										<div className={styles?.type_header}>
											{<Text textContent={item?.voucher_group_desc} style={{ fontWeight: 700, fontSize: "20px", lineHeight: "21px", color: theme.colors.textBlack }} />}
										</div>
										<div className={styles?.table_container}>
											<CollapsibleTable
												keyIndex={0}
												rowClassName="reimbursement-collapsible-table"
												generateCols={generateCols}
												generateData={() => generateTableDisplayData(item?.voucher_group_code?.toString())}
												expandedRowElement={(record) => <ExpandedRowTable columnHeaderData={generateExpandRowHeaders(record.summary_item)} record={record.summary_item} />}
												popOverClose={popOverClose}
											/>
										</div>
									</div>
								);
							})}
						</>
					) : (
						<>
							{
								<div key={`${selectedVoucherGroupCodeDetails?.voucherGroupCode}`}>
									<div className={styles?.type_header}>
										{
											<Text
												textContent={selectedVoucherGroupCodeDetails?.voucherGroupDesc}
												style={{ fontWeight: 700, fontSize: "20px", lineHeight: "21px", color: theme.colors.textBlack }}
											/>
										}
									</div>
									<div className={styles?.table_container}>
										<CollapsibleTable
											keyIndex={0}
											rowClassName="reimbursement-collapsible-table"
											generateCols={generateCols}
											generateData={() => generateTableDisplayData(selectedVoucherGroupCodeDetails?.voucherGroupCode ?? "")}
											expandedRowElement={(record) => <ExpandedRowTable columnHeaderData={generateExpandRowHeaders(record.summary_item)} record={record.summary_item} />}
											popOverClose={popOverClose}
										/>
									</div>
								</div>
							}
						</>
					)}
				</>
			)}
			{childRouteElement}
		</div>
	);
};

export default MonthlyDeclarationPage;
